(ns ui.view.entity-creator.investor.sub
  (:require
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [reagent.ratom :as ratom]
   [ui.view.entity-creator.investor.model :as m]))

(rf/reg-sub
 ;; Shouldn't be used directly - ident needed
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 ;; State specific to a single instance of creator
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]}
      [_ {:keys [ident]}]]
   (get-in root-state ident)))

(defn current-view
  [{:keys [state]}]
  (get state m/current-view-key))

(rf/reg-sub
 m/current-view
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'current-view)

(defn subview
  [{:keys [current-view]}]
  (or current-view :select-legal-entity))

(rf/reg-sub
 m/subview
 (fn [[_ args]]
   {:current-view (rf/subscribe [m/current-view args])})
 #'subview)

(rf/reg-sub
 m/processing?
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/processing-key)))

(rf/reg-sub
 m/creating?
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/creating-key)))

(defn selected-legal-entity
  [{:keys [state]}]
  (get state m/selected-legal-entity-key))

(rf/reg-sub
 m/selected-legal-entity
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'selected-legal-entity)

(rf/reg-sub-raw
 m/investor
 (fn [_ [_ args]]
   (ratom/reaction
    (let [legal-entity @(rf/subscribe [m/selected-legal-entity args])
          legal-entity-id (:db/id legal-entity)]
      (when (number? legal-entity-id)
        (->> @session/investors
             (cu/find-first-by :investor/legal-entity legal-entity-id)))))))
